var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNmHeatMapLM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .dummy-widget-heat-map-nm-cls-1 {\n        fill: #e54040;\n      }\n\n      .dummy-widget-heat-map-nm-cls-1, .dummy-widget-heat-map-nm-cls-2, .dummy-widget-heat-map-nm-cls-3, .dummy-widget-heat-map-nm-cls-4, .dummy-widget-heat-map-nm-cls-5, .dummy-widget-heat-map-nm-cls-6, .dummy-widget-heat-map-nm-cls-7, .dummy-widget-heat-map-nm-cls-8, .dummy-widget-heat-map-nm-cls-9 {\n        stroke-width: 0px;\n      }\n\n      .dummy-widget-heat-map-nm-cls-1, .dummy-widget-heat-map-nm-cls-4, .dummy-widget-heat-map-nm-cls-8, .dummy-widget-heat-map-nm-cls-9 {\n        isolation: isolate;\n        opacity: .7;\n      }\n\n      .dummy-widget-heat-map-nm-cls-2 {\n        fill: #1e1e1e;\n      }\n\n      .dummy-widget-heat-map-nm-cls-10 {\n        clip-path: url(#dummy-widget-heat-map-nm-clippath);\n      }\n\n      .dummy-widget-heat-map-nm-cls-3 {\n        fill: none;\n      }\n\n      .dummy-widget-heat-map-nm-cls-4 {\n        fill: #65b563;\n      }\n\n      .dummy-widget-heat-map-nm-cls-5 {\n        fill: #393a3a;\n      }\n\n      .dummy-widget-heat-map-nm-cls-6 {\n        fill: #444;\n      }\n\n      .dummy-widget-heat-map-nm-cls-7 {\n        fill: #2b2b2b;\n      }\n\n      .dummy-widget-heat-map-nm-cls-8 {\n        fill: #1f1f1f;\n      }\n\n      .dummy-widget-heat-map-nm-cls-9 {\n        fill: #eedd3b;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-heat-map-nm-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-3",
    x: 7.5,
    y: 7.5,
    width: 155.4,
    height: 153.7
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-5",
    y: 0,
    width: 170.1,
    height: 170.1,
    rx: 7.6,
    ry: 7.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-heat-map-nm-cls-10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-heat-map-nm-cls-2",
    d: "M13.8,33.3h142.7c3.4,0,6.2,2.8,6.2,6.2v90.1c0,3.4-2.8,6.2-6.2,6.2H13.8c-3.4,0-6.2-2.8-6.2-6.2V39.5c0-3.4,2.8-6.2,6.2-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-heat-map-nm-cls-7",
    d: "M156.5,136H13.8c-3.5,0-6.4-2.9-6.4-6.4V39.5c0-3.5,2.9-6.4,6.4-6.4h142.7c3.5,0,6.4,2.9,6.4,6.4v90.1c0,3.5-2.9,6.4-6.4,6.4ZM13.8,33.5c-3.3,0-6,2.7-6,6v90.1c0,3.3,2.7,6,6,6h142.7c3.3,0,6-2.7,6-6V39.5c0-3.3-2.7-6-6-6H13.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-6",
    x: 15.4,
    y: 41.1,
    width: 140.1,
    height: 86.8,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 15.4,
    y: 96.6,
    width: 140.1,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 27.1,
    y: 41.1,
    width: 5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 56.1,
    y: 41.1,
    width: 5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 71.2,
    y: 41.1,
    width: 5,
    height: 32.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 100.7,
    y: 111,
    width: 5,
    height: 16.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 128.8,
    y: 41.1,
    width: 5,
    height: 46.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 56.7,
    y: 70.2,
    width: 32.7,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 27.1,
    y: 111.2,
    width: 34.1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 85.2,
    y: 41.1,
    width: 5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 114.3,
    y: 41.1,
    width: 5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 143.4,
    y: 41.1,
    width: 5,
    height: 55.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 27.1,
    y: 103.8,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 56.1,
    y: 103.8,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 85.2,
    y: 103.8,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 114.3,
    y: 103.8,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-heat-map-nm-cls-2",
    x: 143.4,
    y: 103.8,
    width: 5,
    height: 24.1
  }))), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-heat-map-nm-cls-8",
    d: "M14.2-82.1h142.4c3.5,0,6.3,2.8,6.3,6.2V13.9c0,3.4-2.8,6.2-6.3,6.2H14.2c-3.5,0-6.3-2.8-6.3-6.2v-89.8c0-3.4,2.8-6.2,6.3-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-heat-map-nm-cls-8",
    d: "M14.2,148.6h142.4c3.5,0,6.3,2.8,6.3,6.2v86.3c0,3.4-2.8,6.2-6.3,6.2H14.2c-3.5,0-6.3-2.8-6.3-6.2v-86.3c0-3.4,2.8-6.2,6.3-6.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 35.2,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 39.6,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 48.3,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 49.4,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 50.4,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 52.6,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 63.5,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 67.8,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 83,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 61.3,
    cy: 93.4,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 61.3,
    cy: 82.5,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 53.7,
    cy: 108.6,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 26.5,
    cy: 65.2,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 83,
    cy: 67.3,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 83,
    cy: 64.1,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 112.4,
    cy: 85.8,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 123.3,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 124.3,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 127.6,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-9",
    cx: 55.9,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-9",
    cx: 62.4,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-1",
    cx: 59.1,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-4",
    cx: 115.8,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-9",
    cx: 117.8,
    cy: 99.9,
    r: 3.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-heat-map-nm-cls-1",
    cx: 120,
    cy: 99.9,
    r: 3.9
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmHeatMapLM);
export default __webpack_public_path__ + "static/media/nm_heat_map_l-m.225446d8.svg";
export { ForwardRef as ReactComponent };